<template>
  <div>
    <h1>Email templates</h1>
    <v-btn :to="{name:'emailTemplateAdd'}">
      <v-icon>add</v-icon>Email template
    </v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="computedEmailTemplates"
      class="elevation-1"
      v-if="emailTemplates"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              small
              :to="{name:'emailTemplate', params:{id: props.item.id}}"
            >{{ props.item.id }}</v-btn>
          </td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.modified | formatDateTime }}</td>
          <td>{{ props.item.created | formatDateTime }}</td>
          <td>{{ props.item.defaulted }}</td>
          <td>
            <span v-if="props.item.tags">
              <router-link
                v-for="tag in props.item.tags"
                :key="tag.id"
                :to="{name:'emailTemplateTag', params:{id:tag.id}}"
              >{{tag.name}}</router-link>
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "EmailTemplates",
  metaInfo() {
    return {
      title: "Email templates",
      titleTemplate: "%s - Documents - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    computedEmailTemplates() {
      if (!this.emailTemplates) {
        return undefined;
      }
      return this.emailTemplates.map(e => {
        const tags = this.tags ? this.tags[e.id] : undefined;
        return { ...e, tags };
      });
    }
  },
  data() {
    return {
      emailTemplates: null,
      tags: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Modified",
          value: "modified"
        },
        {
          text: "Created",
          value: "created"
        },
        {
          text: "Defaulted",
          value: "defaulted"
        },
        {
          text: "Tags",
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: -1
      }
    };
  },
  methods: {
    fetchEmailTemplates() {
      nbmlaw.get(`/cors/admin/document/emailTemplates`).then(response => {
        // console.log(response.data)
        this.emailTemplates = response.data;
      });
    },
    fetchEmailTemplatesTags() {
      nbmlaw.get(`/cors/admin/document/emailTemplates/tags`).then(response => {
        // console.log(response.data)
        this.tags = response.data;
      });
    }
  },
  created() {
    this.fetchEmailTemplates();
    this.fetchEmailTemplatesTags();
  }
};
</script>
